<template>
  <div class="apply_template_wrapper" v-if="getItem">
    <div class="page page1">
      <div class="box1">{{getItem.productName}}</div>
      <div class="box2"><br/><span class="styleBox">{{getItem.carId}}</span></div>
      <div class="box3">乙</div>
      <div class="box4">{{getItem.vendor.totalPrice}}</div>
      <div class="box5">{{getItem.bankName}}</div>
      <div class="box6">{{getItem.bankSubName}}</div>
      <div class="box7">{{getName}}</div>
      <div class="box8">{{getItem.bankAccount}}</div>
      <div class="box9"></div>
      <div class="box10">{{getItem.secondBankName}}</div>
      <div class="box11">{{getItem.secondBankSubName}}</div>
      <div class="box12">{{getItem.secondName}}</div>
      <div class="box13">{{getItem.secondBankAccount}}</div>
      <div class="box14"></div>
      <div class="box15"></div>
      <div class="box16">{{getItem.customer.memberId}}</div>
      <div class="box17">{{getItem.customer.home.residenceAddress}}</div>
      <div class="box18">{{getItem.customer.cellphone}}</div>
      <div class="box19"></div>
      <div class="box20"></div>
      <div class="box21"></div>
      <div class="box22"></div>
<!--              <div class="itemDetail">-->
<!--                名稱：<span class="pro pro_1">{{getItem.productName}}</span>；型號：-->
<!--                <span class="pro pro_2"><br/><span class="styleBox">{{getItem.carId}}</span></span>；-->
<!--                數量：<span class="pro pro_3">乙</span>；價金總額：<span class="pro pro_mn">{{getItem.vendor.totalPrice}}</span>元。-->
<!--              </div>-->

<!--                <table class="table table1">-->
<!--                  <tr>-->
<!--                    <th width="47px">銀行</th>-->
<!--                    <td width="215px">{{getItem.bankName}}</td>-->
<!--                    <th width="47px">分行</th>-->
<!--                    <td>{{getItem.bankSubName}}</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <th>戶名</th>-->
<!--                    <td>{{getName}}</td>-->
<!--                    <th>帳號</th>-->
<!--                    <td>{{getItem.bankAccount}}</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <th>金額</th>-->
<!--                    <td colspan="3"></td>-->
<!--                  </tr>-->
<!--                </table>-->

<!--                <table class="table table2">-->
<!--                  <tr>-->
<!--                    <th width="47px">銀行</th>-->
<!--                    <td width="215px"></td>-->
<!--                    <th width="47px">分行</th>-->
<!--                    <td></td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <th>戶名</th>-->
<!--                    <td v-if="getItem.vendor.productId === '2'">{{getItem.customer.name}}</td>-->
<!--                    <th>帳號</th>-->
<!--                    <td></td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <th>金額</th>-->
<!--                    <td colspan="3"></td>-->
<!--                  </tr>-->
<!--                </table>-->

<!--          <div class="sign">-->
<!--            <div class="signName"></div>-->
<!--            <div class="signID">{{getItem.customer.memberId}}</div>-->
<!--            <div class="signADD">{{getItem.customer.home.residenceAddress}}</div>-->
<!--            <div class="signPhone">{{getItem.customer.cellphone}}</div>-->
<!--            <div class="signName2"></div>-->
<!--          </div>&lt;!&ndash;sign&ndash;&gt;-->
<!--          <div class="date">-->
<!--            中華民國<span class="d d1"></span>年<span class="d d2"></span>月<span class="d d3"></span>日-->
<!--          </div>-->

        </div>
    <!--page1-->
  </div>
  <!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ApplyTemplatePage",
  data() {
    return {
      item: null,
      status: false,
      now: new Date(),
    };
  },
  created() {
    const caseId = this.$route.query.caseId;
    this.status = parseInt(this.$route.query.caseCategory, 10);
    if (caseId) {
      this.fetchFinanceCreditInfo({ caseId }).then((results) => {
        if (results.length) {
          this.item = results[0];
          console.log(`fetchFinanceCreditInfo === ${JSON.stringify(this.item)}`);
          if (this.item.vendor.productId === "1") {
            // 借新還舊
            this.item.secondBankName = this.item.bankName;
            this.item.secondBankSubName = this.item.bankSubName;
            this.item.secondName = this.item.customer.name;
            this.item.secondBankAccount = this.item.bankAccount;

            this.item.bankName = "華南銀行";
            this.item.bankSubName = "敦化分行";
            this.item.customer.name = "裕富數位資融股份有限公司";
            this.item.bankAccount = "130100030060";

          } else if (this.item.vendor.productId === "2") {
            // 他行代償
            this.item.secondBankName = this.item.bankName;
            this.item.secondBankSubName = this.item.bankSubName;
            this.item.secondName = this.item.customer.name;
            this.item.secondBankAccount = this.item.bankAccount;

            this.item.bankName = this.item.beforeBankName;
            this.item.name = this.item.beforeName;
            this.item.bankSubName = this.item.beforeBankSubName;
            this.item.bankAccount = this.item.beforeBankAccount;
          } else {
            this.item.secondBankName = '';
            this.item.secondBankSubName = '';
            this.item.secondName = '';
            this.item.secondBankAccount = '';
          }
          console.log(`fetchFinanceCreditInfo ${JSON.stringify(this.item)}`);
        }
      });
    }
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    getItem() {
      return this.item;
    },
    getCreateDate() {
      return new Date(this.getItem.createDate);
    },
    getName() {
      if (this.getItem.vendor.productId === "2") {
        return this.getItem.name;
      }
      return this.getItem.customer.name;
    },
  },
  methods: {
    ...mapActions(["fetchFinanceCreditInfo"]),
  },
};
</script>

<style scoped src="../../assets/css/apply_template_page.css">
</style>



// WEBPACK FOOTER //
// src/pages/web/ApplyTemplatePage.vue